import React from 'react'
import '../../Global.css';
import './index.css';
import TopHref1 from "../../static/img/Index/TopHref1.svg";
import TopHref2 from "../../static/img/Index/TopHref2.svg";
import TopHref3 from "../../static/img/Index/TopHref3.svg";
import TopHref4 from "../../static/img/Index/TopHref4.svg";
import TopHref5 from "../../static/img/Index/TopHrefmt4.png";
import TopHref6 from "../../static/img/Index/mobius7.png";
import DepositSystem01 from "../../static/img/Index/System/bankcard.svg";
import DepositSystem02 from "../../static/img/Index/System/bitcoin.svg";
import DepositSystem03 from "../../static/img/Index/System/dash.svg";
import DepositSystem04 from "../../static/img/Index/System/Skrill.svg";
import DepositSystem05 from "../../static/img/Index/System/webmoney.svg";
import DepositSystem06 from "../../static/img/Index/System/ether.svg";
import DepositSystem07 from "../../static/img/Index/System/litecoin.svg";
import DepositSystem08 from "../../static/img/Index/System/payeer.svg";
import SelectBanner from "./Banners/SelectBanner";
import TISComponent from "./TISComponent";
import ChangeLink from "../../Elements/ChangeLink/ChangeLink";
import LayoutMain from "../../Elements/LayoutMain/LayoutMain";
import QueryNewsIndex from "./QueryNewsIndex/QueryNewsIndex";
import TextChange from "../../../AdminPart/src/Elements/TextChange/TextChange";



function GatsbyIndexPageSource (props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
        } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}


        return (
            <LayoutMain title={props.title} description={props.description} lang={props.lang} AllMenu={['ElementMenuActive','','','','','']} Active={0}>

                <main className="IndexMain StandartPage">
                    <div className="IndexBlocksOutOut">
                        <SelectBanner lang={props.lang} data={props.data} PrerenderTexts={props.PrerenderTexts}/>
                    </div>
                    <div className="IndexMainTopHref">
                        <div className="IndexMainTopHrefElement">
                            <ChangeLink lang={props.lang} to='/account/demo'>
                            <div className="IndexMainTopHrefElementIMG"> <img src={TopHref4}  alt='Ifyoudontseeimages' width='52px'/></div>
                            <div className="IndexMainTopHrefElementText"><TextSource ArrIndex= 'index0000'>Open a Free Demo</TextSource></div>
                        </ChangeLink>
                        </div>
                        <div className="IndexMainTopHrefElement">
                            <ChangeLink lang={props.lang} to='/invest/monitoring'>
                            <div className="IndexMainTopHrefElementIMG"> <img src={TopHref2}  alt='Ifyoudontseeimages' width='52px'/></div>
                            <div className="IndexMainTopHrefElementText"><TextSource ArrIndex= 'index0005'>Investment</TextSource></div>
                            </ChangeLink>
                        </div>
                        <div className="IndexMainTopHrefElement">
                            <ChangeLink lang={props.lang} to='/education/mt4/'>
                            <div className="IndexMainTopHrefElementIMG"> <img src={TopHref1}  alt='Ifyoudontseeimages' width='52px'/></div>
                            <div className="IndexMainTopHrefElementText"><TextSource ArrIndex= 'index0010'>FXSchool for Beginners</TextSource></div>
                            </ChangeLink>
                        </div>
                        <div className="IndexMainTopHrefElement">
                            <ChangeLink lang={props.lang} to='/trading-tools/metatrader4'>
                            <div className="IndexMainTopHrefElementIMG"> <img src={TopHref5}  alt='Ifyoudontseeimages' width='52px'/></div>
                            <div className="IndexMainTopHrefElementText"><TextSource ArrIndex= 'index0015'>Mobius Trader 7</TextSource></div>
                            </ChangeLink>
                        </div>
                        <div className="IndexMainTopHrefElement">
                            <ChangeLink lang={props.lang} to='/terminals/mt7/web'>
                            <div className="IndexMainTopHrefElementIMG"> <img src={TopHref3}  alt='Ifyoudontseeimages' width='52px'/></div>
                            <div className="IndexMainTopHrefElementText"><TextSource ArrIndex= 'index0020'>Webterminal</TextSource></div>
                            </ChangeLink>
                        </div>
                    </div>
                    <div className="IndexBigElements">
                        <QueryNewsIndex lang={props.lang} PrerenderTexts={props.PrerenderTexts}/>
                        <div className="IndexMT7">
                            <div className="IndexMT7Title">MobiusTrader 7 </div>
                            <div className="IndexMT7Body">
                                <div className="IndexMT7BodyIMG"><img src={TopHref6}  alt='Ifyoudontseeimages'/></div>
                            <div className="IndexMT7Text">
                                <div className="IndexMT7TextLink"><ChangeLink lang={props.lang} to={"/terminals/mt7/web"}>MobiusTrader 7</ChangeLink></div>
                            <TextSource ArrIndex= 'index0030'>MobiusTrader 7 is an innovative trading software with all the analytical tools that the trader may need for trading successfully in the financial markets. Being one of a kind it also allows trading cryptocurrencies.</TextSource></div>
                            </div>
                        </div>

                        <div className="IndexLiquidity">
                        <div className="IndexLiquidityIn">
                            <div className="IndexLiquidityTitle"><TextSource ArrIndex= 'index0035'>Liquidity Providers</TextSource></div>
                            <div className="IndexLiquidityText">
                                <TextSource ArrIndex= 'index0040'>Deutsche bank, Baraclays, UBS, Morgan Stanley, Credit Sulsse, CitiBank, BNP Parlbas, HSBC</TextSource>
                            </div>
                            <div className="IndexLiquidityHref"><ChangeLink lang={props.lang} to={"/providers"}><TextSource ArrIndex= 'index0045'>SHOW ALL</TextSource></ChangeLink></div>
                        </div>
                        </div>
                    </div>
                    <TISComponent data={props.data}  PrerenderTexts={props.PrerenderTextsTIS} lang={props.lang} />

                    <ChangeLink lang={props.lang} to={`/funds/deposit`} style={{textDecoration: 'none'}}>
                        <div className="IndexBigDPWD">
                            <div className="IndexBigDPWDTTop">
                                <div className="IndexBigDPWDTTopTitle"><TextSource ArrIndex= 'index0050'>Deposit & Withdrawal</TextSource></div>
                                <div className="IndexBigDPWDTTopMiddle"/>
                                <div className="IndexBigDPWDTTopHref"><TextSource ArrIndex= 'index0055'>More Methods</TextSource></div>
                            </div>
                            <div className="IndexBigDPWDBottom">
                                <div className="IndexBigDPWDBottomElement"><img src={DepositSystem01}  alt='Ifyoudontseeimages' height={'40px'}/></div>
                                <div className="IndexBigDPWDBottomElement"><img src={DepositSystem02}  alt='Ifyoudontseeimages' height={'40px'}/></div>
                                <div className="IndexBigDPWDBottomElement"><img src={DepositSystem03}  alt='Ifyoudontseeimages' height={'40px'}/></div>
                                <div className="IndexBigDPWDBottomElement"><img src={DepositSystem04}  alt='Ifyoudontseeimages' height={'40px'}/></div>
                                <div className="IndexBigDPWDBottomElement"><img src={DepositSystem05}  alt='Ifyoudontseeimages' height={'40px'}/></div>
                                <div className="IndexBigDPWDBottomElement"><img src={DepositSystem06}  alt='Ifyoudontseeimages' height={'40px'}/></div>
                                <div className="IndexBigDPWDBottomElement"><img src={DepositSystem07}  alt='Ifyoudontseeimages' height={'40px'}/></div>
                                <div className="IndexBigDPWDBottomElement"><img src={DepositSystem08}  alt='Ifyoudontseeimages' height={'40px'}/></div>
                            </div>
                        </div>
                    </ChangeLink>
                </main>
            </LayoutMain>
        )}
export default GatsbyIndexPageSource




